export default __webpack_public_path__ + "static/media/right_arrow.eb4a63e1.svg";